import { lazy } from 'react';
import PageView from './PageView';

const DowngradeSchedulePage = lazy(() => import('src/pages/downgradeSchedule'));

export const downgradeScheduleRoutes = [
  {
    path: 'downgrade-schedule',
    element: <PageView permission="BO_CAN_VIEW_DOWNGRADE_SCHEDULE" />,
    children: [{ element: <DowngradeSchedulePage />, index: true }],
  },
];
